module.exports = "<div id=\"page_component\" dynamicPage></div>\n\n"